import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTimeService } from '../../service/data-time.service';

/**
 * Single warning shown shortly before the fixed session ceiling.
 *
 * There is no EXTEND action: the realm has SSO Session Idle = SSO Session Max, so refreshing
 * cannot move the expiry. The only thing the user can do is save their work and log in again.
 */
@Component({
  selector: 'app-extend-time-modal',
  templateUrl: './extend-time-modal.component.html',
  styleUrls: ['./extend-time-modal.component.scss']
})
export class ExtendTimeModalComponent implements OnInit {
  remainingTime = 0;
  constructor(private activeModal: NgbActiveModal
    , private router: Router
    , private dataTimeService: DataTimeService) {
    this.dataTimeService.getObservable().subscribe(x => {
      this.remainingTime = x;
    });
  }

  ngOnInit() {}

  dismiss(): void {
    this.activeModal.dismiss();
  }

  login(): void {
    this.router.navigateByUrl('/login');
    this.activeModal.dismiss();
  }

}
